import { createCourse } from '@/redux/actions/courses'
import { formValidator, resetFormValidator } from '@/redux/actions/validator'
import { IRootState } from '@/redux/types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ICourse } from '../../../models/course'

function useHandleSubmit(courseState: ICourse, handleCloseModalCourse: () => void) {
  const dispatch = useDispatch()

  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())
      dispatch(createCourse(courseState))
      handleCloseModalCourse()
    }
  }, [isValidForm])

  const handleSubmit = () => {
    dispatch(
      formValidator({
        title: [courseState.title, 'required|max:255|min:2'],
        duration: [courseState.duration, 'required|numeric|min:0', 'addOn'],
        brands: [courseState.brand, 'required'],
        countries: [courseState.countries, 'notempty', 'general'],
        languages: [courseState.languages, 'notempty', 'general'],
        responsibles: [courseState.responsibles, 'notempty', 'general'],
        role: [courseState.role, 'notempty', 'general']
      })
    )
  }

  return { handleSubmit }
}

export default useHandleSubmit
